import { render, staticRenderFns } from "./instagram-downloaded-video-blurry.vue?vue&type=template&id=23bf2fc4"
import script from "./instagram-downloaded-video-blurry.vue?vue&type=script&lang=js"
export * from "./instagram-downloaded-video-blurry.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports